import { HistoryTimeframe } from '@shapeshiftoss/types'

export const DEFAULT_HISTORY_TIMEFRAME = HistoryTimeframe.MONTH
export const MINIMUM_KK_FIRMWARE_VERSION_SUPPORTING_LITECOIN = '7.4.0'
export const MINIMUM_KK_FIRMWARE_VERSION_SUPPORTING_EIP712 = '7.6.0'
